<template>
    <div class="page-main">
        <div class="search-bar">
            <div class="left-bar">
                <Button :type="filters.timeSolt===1?'primary':'default'" v-on:click="changeTimeSolt(1)">近一周</Button>
                <Button :type="filters.timeSolt===2?'primary':'default'" v-on:click="changeTimeSolt(2)">近一月</Button>
                <Button :type="filters.timeSolt===3?'primary':'default'" v-on:click="changeTimeSolt(3)">近一年</Button>
            </div>
            <div class="right-bar">
                <div class="right-mian_active" style="float: right;">
                    <input placeholder="请输入教师姓名" class="input-cla" v-model="filters.keyWord"
                           v-on:keyup.enter="handleSearch"/>
                    <div class="search-btn" v-on:click="handleSearch">
                        <div class="search-icon">
                            <img src="../../../../assets/images/databoard/detailPage/search.png" width="100%"
                                 height="100%"/>
                        </div>
                    </div>
                </div>
                <!--<div class="data-right-bar">-->
                    <!--<Button type="primary" v-on:click="exportTeacherExcel()">导出Excel</Button>-->
                <!--</div>-->
            </div>
        </div>

        <div class="table-main-wrap dta-details-table">
            <!--<Table border stripe :columns="teacherColumns" :data="teacherList"-->
            <!--:row-class-name="rowClassName"></Table>-->
            <div class="table-main">
                <div class="table-content">
                    <div class="header">
                        <Col :span="3">
                            <span>序号</span>
                        </Col>
                        <Col :span="8">
                            <span>学校名称</span>
                        </Col>
                        <Col :span="6">
                            <span>教师姓名</span>
                        </Col>
                        <!--<Col :span="3">-->
                        <!--<span>用户名</span>-->
                        <!--</Col>-->
                        <!--<Col :span="3">-->
                        <!--<span>手机号</span>-->
                        <!--</Col>-->
                        <!--<Col :span="5">-->
                        <!--<span>任教班级</span>-->
                        <!--</Col>-->
                        <Col :span="7">
                            <span>任教学科</span>
                        </Col>
                    </div>
                    <div class="row-wrap">
                        <template v-for="(item,index) in teacherList" v-if="teacherList.length>0">
                            <Row :class="index % 2 === 0 ? 'row-single':'row-double'" :gutter="12">
                                <Col :span="3" class="col-content">
                                    <span>{{item.rowNum}}</span>
                                </Col>
                                <Col :span="8" class="col-content">
                                    <span>{{item.schoolName ==='' ? '暂无':item.schoolName}}</span>
                                </Col>
                                <Col :span="6" class="col-content">
                                    <span>{{item.display_name ==='' ? '暂无':item.realname}}</span>
                                </Col>
                                <!--<Col :span="3" class="col-content">-->
                                <!--<span>{{item.userName ==='' ? '暂无':item.userName}}</span>-->
                                <!--</Col>-->
                                <!--<Col :span="3" class="col-content">-->
                                <!--<span>{{item.mobile ==='' ? '暂无':item.mobile}}</span>-->
                                <!--</Col>-->
                                <!--<Col :span="5" class="col-content">-->
                                <!--<span>{{item.teachClassName ==='' ? '暂无':item.teachClassName}}</span>-->
                                <!--</Col>-->
                                <Col :span="7" class="col-content">
                                    <span>{{item.subNameList ==='' ? '暂无':item.subNameList}}</span>
                                </Col>
                            </Row>
                        </template>
                        <template v-if="teacherList.length===0">
                            <Row :gutter="12" class="row-single">
                                <Col :span="24">
                                    <span>暂无数据</span>
                                </Col>
                            </Row>
                        </template>
                    </div>
                </div>
            </div>
            <div class="bottom-page">
                <div class="laypage_main">
                    <Page :total="pageParams.total" @on-change="handleCurrentChange" :current="pageParams.page"
                          v-if="pageParams.total && pageParams.pageCount>1"></Page>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {findTeacherList, getTeacherSchoolList, exportTeacherExcel} from "../../../../service/api.js";

    export default {
        name: "teacher-list",
        data () {
            return {
                teacherList: [],
                filters: {
                    schoolId: this.$route.params.schoolId == 0 ? '' : this.$route.params.schoolId,
                    timeSolt: 1,
                    keyWord: '',
                    startDate: '',
                    endDate: ''
                },
                pageParams: {
                    page: 1,
                    limit: 10,
                    total: 0,
                    pageCount: 0
                },
                teacherColumns: [
                    // {
                    //     title: '序号',
                    //     key: 'rowNum',
                    //     align: "center"
                    // },
                    // {
                    //     title: '教师名称',
                    //     key: 'display_name',
                    //     align: "center",
                    //     width: "140px"
                    // },
                    // {
                    //     title: '学科名称',
                    //     key: 'bank_name',
                    //     align: "center"
                    // },
                    // {
                    //     title: '布置作业份数',
                    //     key: 'subNub',
                    //     align: "center"
                    // },
                    // {
                    //     title: '布置作业次数',
                    //     key: 'freQuency',
                    //     align: "center"
                    // },
                    // {
                    //     title: '学生数',
                    //     key: 'students',
                    //     align: "center"
                    // },
                    // {
                    //     title: '提交学生数',
                    //     key: 'submit_stus',
                    //     align: "center"
                    // },
                    // {
                    //     title: '批改学生数',
                    //     key: 'complete_stus',
                    //     align: "center"
                    // },
                    // {
                    //     title: '作业提交率',
                    //     key: 'subRates',
                    //     align: "center"
                    // },
                    // {
                    //     title: '作业批改率',
                    //     key: 'correRate',
                    //     align: "center"
                    // }
                ]
            }
        },
        created () {
            let currentPathArr;
            currentPathArr = [
                {
                    title: "首页",
                    path: "databoard",
                    name: "databoard",
                    params: {
                        schoolCode: this.$route.params.schoolCode,
                    }
                },
                {
                    title: this.$route.params.schoolName,
                    path: "",
                    name: "schoolName"
                },
                {
                    title: "全部教师",
                    path: "",
                    name: "teacherList"
                }
            ];
            this.$store.commit("setCurrentPath", currentPathArr);
        },
        methods: {
            /**
             * 获取教师列表  更改的代码
             */
            async getTeacherList () {
                let _this = this;
                let params = {
                    schoolId: _this.filters.schoolId,
                    keyWord: _this.filters.keyWord,
                    startDate: _this.filters.startDate,
                    endDate: _this.filters.endDate,
                    timeType:_this.filters.timeSolt,
                    page: _this.pageParams.page,
                    limit: _this.pageParams.limit
                };
                let resultData = await findTeacherList(params).catch(function (error) {
                    _this.$Message.error(error.message);
                });
                _this.teacherList = resultData.rows;
                _this.pageParams.total = resultData.total_rows;
                _this.pageParams.pageCount = resultData.page_count;
            },
            /**
             * 导出excel
             */
            exportTeacherExcel () {
                let url =
                    BASE_URL +
                    "/website/bord/exportTeacherExcel?schoolId=" +
                    this.filters.schoolId + "&startDate=" + this.filters.startDate + "&endDate=" + this.filters.endDate;
                let iframe = document.createElement("iframe");
                iframe.style.display = "none";
                iframe.src = url;
                iframe.onload = function () {
                    document.body.removeChild(iframe);
                };
                document.body.appendChild(iframe);
            },
            // /**
            //  * 获取教师列表
            //  */
            // async getTeacherSchoolList () {
            //     let _this = this;
            //     let params = {
            //         schoolId: _this.filters.schoolId,
            //         keyWord: _this.filters.keyWord,
            //         startDate: _this.filters.startDate,
            //         endDate: _this.filters.endDate,
            //         page: _this.pageParams.page,
            //         limit: _this.pageParams.limit
            //     };
            //     let resultData = await getTeacherSchoolList(params).catch(function (error) {
            //         _this.$Message.error(error.message);
            //     });
            //     _this.teacherList = resultData.rows;
            //     _this.pageParams.total = resultData.total_rows;
            //     _this.pageParams.pageCount = resultData.page_count;
            // },
            /**
             * 翻页
             */
            handleCurrentChange (val) {
                this.pageParams.page = val;
                this.getTeacherList();
                // this.getTeacherSchoolList();
            },
            /**
             * 查询
             */
            handleSearch () {
                this.pageParams.total = 0;
                this.pageParams.page = 1;
                this.pageParams.pageCount = 0;
                this.getTeacherList();
                // this.getTeacherSchoolList();
            },
            /**
             * 表格斑马纹
             */
            rowClassName (row, index) {
                if (index % 2 == 0) {
                    return 'ivu-table-stripe-even';
                } else return 'ivu-table-stripe-odd';
            },
            /**
             * 选择时间段
             */
            changeTimeSolt (type) {
                // 反选的情况
                if (this.filters.timeSolt === type) {
                    this.filters.timeSolt = 0;
                    this.filters.startDate = '';
                    this.filters.endDate = '';
                } else {
                    this.filters.timeSolt = type;
                }
                //获取近一周时间
                if (this.filters.timeSolt === 1) {
                    this.filters.startDate = this.$utils.getWeekStartDate() + ' 00:00:00';
                    this.filters.endDate = this.$utils.getWeekEndDate() + ' 23:59:59';
                } else if (this.filters.timeSolt === 2) {
                    //获取近一月时间
                    this.filters.startDate = this.$utils.getMonthStartDate() + ' 00:00:00';
                    this.filters.endDate = this.$utils.getMonthEndDate() + ' 23:59:59';
                } else if (this.filters.timeSolt === 3) {
                    //获取近一年时间
                    this.filters.startDate = this.$utils.getYearStartDate() + ' 00:00:00';
                    this.filters.endDate = this.$utils.getYearEndDate() + ' 23:59:59';
                }
                this.handleSearch();
            }
        },
        mounted () {
            this.getTeacherList();
            // this.getTeacherSchoolList();
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../../../style/detailPage";
</style>
<style lang="scss">
    .dta-details-table {
        tr {
            height: 2.60417vw;
            line-height: 2.60417vw;
            text-align: center;
        }

        .ivu-table-column-center {
            border-right: 0;
            font-weight: 500;
        }

        .ivu-table th {
            background: #f3f7f6;
        }

        .ivu-table td, .ivu-table th {
            border-bottom: 0;
        }

        .ivu-table-wrapper {
            border: 1px solid #efefef;
        }

        .ivu-table-overflowX {
            overflow-x: hidden !important;
        }

        .ivu-table-tip {
            overflow-x: hidden !important;
        }
    }

    .new-data-table-main-wrap .ivu-table th {
        border-bottom: 1px solid #efefef;
    }

    /*偶数行*/
    .ivu-table-stripe-even td {
        background-color: #fff !important;
    }

    /*奇数行*/
    .ivu-table-stripe-odd td {
        background-color: #fafbfd !important;
    }
</style>
